export default "assets/images/logo-cursive-03b63d40.png";